// TCU Constants

export const ADMIN_ROUTE_TCUS = "tcus";
export const ADMIN_ROUTE_TCU_VIEW = `${ADMIN_ROUTE_TCUS}/view`;
export const ADMIN_ROUTE_TCU_FORM = `${ADMIN_ROUTE_TCUS}/form`;
